/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerFindProjectsInTeamQueryResponse, TeamsControllerFindProjectsInTeamPathParams, TeamsControllerFindProjectsInTeamQueryParams, TeamsControllerFindProjectsInTeam401, TeamsControllerFindProjectsInTeam403, TeamsControllerFindProjectsInTeam404 } from "../../models/teamsController/TeamsControllerFindProjectsInTeam";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { teamsControllerFindProjectsInTeam } from "../../clients/teamsService/teamsControllerFindProjectsInTeam";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const teamsControllerFindProjectsInTeamQueryKey = (id: TeamsControllerFindProjectsInTeamPathParams["id"], params: TeamsControllerFindProjectsInTeamQueryParams = {}) => [{
  url: '/api/v1/teams/:id/projects',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TeamsControllerFindProjectsInTeamQueryKey = ReturnType<typeof teamsControllerFindProjectsInTeamQueryKey>;
export function teamsControllerFindProjectsInTeamQueryOptions(id: TeamsControllerFindProjectsInTeamPathParams["id"], params?: TeamsControllerFindProjectsInTeamQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = teamsControllerFindProjectsInTeamQueryKey(id, params);
  return queryOptions<TeamsControllerFindProjectsInTeamQueryResponse, ResponseErrorConfig<TeamsControllerFindProjectsInTeam401 | TeamsControllerFindProjectsInTeam403 | TeamsControllerFindProjectsInTeam404>, TeamsControllerFindProjectsInTeamQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return teamsControllerFindProjectsInTeam(id, params, config);
    }
  });
}

/**
 * @summary Get all projects in a team
 * {@link /api/v1/teams/:id/projects}
 */
export function useTeamsControllerFindProjectsInTeam<TData = TeamsControllerFindProjectsInTeamQueryResponse, TQueryData = TeamsControllerFindProjectsInTeamQueryResponse, TQueryKey extends QueryKey = TeamsControllerFindProjectsInTeamQueryKey>(id: TeamsControllerFindProjectsInTeamPathParams["id"], params?: TeamsControllerFindProjectsInTeamQueryParams, options: {
  query?: Partial<QueryObserverOptions<TeamsControllerFindProjectsInTeamQueryResponse, ResponseErrorConfig<TeamsControllerFindProjectsInTeam401 | TeamsControllerFindProjectsInTeam403 | TeamsControllerFindProjectsInTeam404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? teamsControllerFindProjectsInTeamQueryKey(id, params);
  const query = useQuery({
    ...teamsControllerFindProjectsInTeamQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TeamsControllerFindProjectsInTeam401 | TeamsControllerFindProjectsInTeam403 | TeamsControllerFindProjectsInTeam404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}